import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";

const state = {
  dataUserDashboard: null
};
const getters = {
  dataUserDashboard: (state) => state.dataUserDashboard
};

const actions = {
  [actionType.GET_DATA_USER_DASHBOARD]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("/user/dashboard").then(result => {
        commit(mutationType.SET_DATA_USER_DASHBOARD, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  }
};

const mutations = {
  [mutationType.SET_DATA_USER_DASHBOARD](state, data) {
    state.dataUserDashboard = data.data
  },
  [mutationType.SET_DATA_USER_DASHBOARD_MESSAGE](state, data) {
    state.dataUserDashboard.message = data.data.message;
  },
  [mutationType.UPDATE_UNREAD_MESSAGE_USER_DASHBOARD](state, number) {
    if(number) {
      if(state.dataUserDashboard && state.dataUserDashboard.message) {
        state.dataUserDashboard.message = state.dataUserDashboard.message - number
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}